<div class="home-container">
  
  <!-- Hero Section -->
  <section class="hero">
    <!-- Decorative ambient circles (same as login left panel) -->
    <div class="hero-deco">
      <div class="hero-deco-circle hero-deco-circle--1"></div>
      <div class="hero-deco-circle hero-deco-circle--2"></div>
      <div class="hero-deco-circle hero-deco-circle--3"></div>
      <div class="hero-deco-circle hero-deco-circle--4"></div>
    </div>

    <div class="hero-content">
      <img src="/assets/imagotipo.png" alt="BarBook" class="hero-logo" />
      <h1 class="hero-title">
        Tus <span class="highlight">bares</span> de cualquier lugar, en un solo <span class="highlight">lugar</span>
      </h1>
      <p class="hero-subtitle">
        Busca, explora y organiza tus lugares favoritos. Crea listas personalizadas y comparte experiencias únicas.
      </p>
      
      <!-- Search Bar -->
      <div class="search-bar">
        <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
        <input 
          type="text" 
          (click)="navigateToSearch()"
          readonly
          placeholder="Buscar bares, ubicación..."
          class="search-input"
        />
        <button class="search-button" (click)="navigateToSearch()">
          Buscar
        </button>
      </div>
    </div>
  </section>

  <!-- Features Section -->
  <section class="features">
    <h2 class="features-title">¿Qué puedes hacer con BarBook?</h2>
    
    <div class="features-grid">
      
      <!-- Feature 1: Búsqueda -->
      <div class="feature-card">
        <div class="feature-icon search">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
        </div>
        <h3 class="feature-title">Busca y Descubre</h3>
        <p class="feature-description">
          Encuentra bares con información completa: teléfono, horarios, precios, ubicación y fotos. Datos conectados con Google para máxima precisión.
        </p>
      </div>

      <!-- Feature 2: Listas -->
      <div class="feature-card">
        <div class="feature-icon lists">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="8" y1="6" x2="21" y2="6"></line>
            <line x1="8" y1="12" x2="21" y2="12"></line>
            <line x1="8" y1="18" x2="21" y2="18"></line>
            <line x1="3" y1="6" x2="3.01" y2="6"></line>
            <line x1="3" y1="12" x2="3.01" y2="12"></line>
            <line x1="3" y1="18" x2="3.01" y2="18"></line>
          </svg>
        </div>
        <h3 class="feature-title">Crea Listas Personalizadas</h3>
        <p class="feature-description">
          Organiza tus bares favoritos en listas públicas, privadas o colaborativas. Perfectas para planificar viajes o salidas con amigos.
        </p>
      </div>

      <!-- Feature 3: Comunidad -->
      <div class="feature-card">
        <div class="feature-icon community">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </div>
        <h3 class="feature-title">Sigue y Comparte</h3>
        <p class="feature-description">
          Descubre listas públicas de otros usuarios y encuentra inspiración. Comparte tus descubrimientos con la comunidad.
        </p>
      </div>

    </div>
  </section>

  <!-- CTA Section -->
  <section class="cta">
    <h2 class="cta-title">¡Descarga BarBook ahora!</h2>
    <p class="cta-subtitle">Disponible para iOS y Android. Lleva los mejores bares en tu bolsillo.</p>
    <div class="download-buttons">
      <a href="https://apps.apple.com/es/app/barbook-agenda-de-bares/id6740002036" target="_blank" rel="noopener noreferrer" class="download-btn">
        <img src="/assets/appstore.svg" alt="Descargar en App Store" />
      </a>
      <a href="https://play.google.com/store/apps/details?id=com.adrcanfer.barbook" target="_blank" rel="noopener noreferrer" class="download-btn">
        <img src="/assets/playstore.png" alt="Descargar en Google Play" />
      </a>
    </div>
  </section>

</div>
